import type { PostHog } from 'posthog-js'

let resolvePosthog: (posthog: PostHog) => void = () => {}

/**
 * PostHog once app/plugins/posthog.client.ts has loaded and initialised it.
 * It is loaded after the app has mounted, so it stays out of the first download;
 * never import posthog-js statically, or it lands in the entry chunk again.
 */
export const posthogReady = new Promise<PostHog>((resolve) => { resolvePosthog = resolve })

export const setPosthog = (posthog: PostHog) => resolvePosthog(posthog)
